import { IconButton, Tooltip, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { Term } from '../types/term';
import Icons from '../../../components/icons';

export const getTermsColumns = (
  handleDelete: (term: Term) => void,
  handleEdit: (term: Term) => void
): GridColDef[] => [
  {
    field: 'id',
    headerName: 'ID'
  },
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    minWidth: 150,
    renderCell: (params) => (
      <Typography
        variant='body2'
        fontWeight={500}
        height={40}
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: '100%'
        }}
      >
        {params.value}
      </Typography>
    )
  },

  {
    field: 'edit',
    headerName: 'Edit',
    flex: 0.5,
    maxWidth: 80,
    minWidth: 80,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params) => (
      <Tooltip title='Edit'>
        <IconButton onClick={() => handleEdit(params.row)}>
          <Icons.EditBlackOutlined />
        </IconButton>
      </Tooltip>
    )
  },
  {
    field: 'delete',
    headerName: 'Delete',
    flex: 0.5,
    maxWidth: 80,
    minWidth: 80,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params) => {
      return (
        <Tooltip title='Delete'>
          <IconButton onClick={() => handleDelete(params.row)}>
            <Icons.Delete width={20} height={20} />
          </IconButton>
        </Tooltip>
      );
    }
  }
];
